import { List as ProductsList } from './List';

export default ProductsList;
